export const fiDvmChassisPart = {
  BLADES: 'blades',
  PEM: 'pem',
  PWRFEED: 'pwr_feed',
  FANTRAY: 'fan_tray',
  SHELFMGR: 'shelf_manager',
  SAP: 'sap',
};
